import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { breakpoints } from '@/css/resources/variables.css';
import {
	grid,
	resetFirstChildMarginTop,
	resetLastChildMarginBottom,
} from '@/css/resources/placeholders.css';
import { fontStyle, fluidPadding } from '@/css/resources/mixins.css';
import {
	getColumnLeftStyle,
	getColumnRightStyle,
} from '@/css/shared/columns.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidPadding(styles?.padding), {
		background: styles?.backgroundColor,

		'.supt-section__inner': {
			'.supt-section__col--left': getColumnLeftStyle(
				styles?.columns?.content
			),
			'.supt-section__col--right': getColumnRightStyle(
				styles?.columns?.content
			),

			'.supt-section__headline': cssObj(
				getColumnLeftStyle(styles?.columns?.headline),
				{
					'.supt-section__uptitle': fontStyle({
						...styles?.uptitle?.typography,
						textAlign: styles?.uptitle?.textAlignment,
						color: styles?.uptitle?.color,
					}),
					'.supt-section__title': fontStyle({
						...styles?.title?.typography,
						textAlign: styles?.title?.textAlignment,
						color: styles?.title?.color,
					}),
					'.supt-section__introduction': fontStyle({
						...styles?.introduction?.typography,
						textAlign: styles?.introduction?.textAlignment,
						color: styles?.introduction?.color,
					}),
				}
			),
		},

		'&.supt-section--twoCol--firstColIsRight': {
			'.supt-section__inner': {
				'.supt-section__col--right': getColumnLeftStyle(
					styles?.columns?.content
				),
				'.supt-section__col--left': getColumnRightStyle(
					styles?.columns?.content
				),
			},
		},

		'.supt-introduction': fontStyle({
			...styles?.introduction?.typography,
			textAlign: styles?.introduction?.textAlignment,
			color: styles?.introduction?.color,
		}),
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		'.supt-section__inner': cssObj(grid, {
			'.supt-section__headline': cssObj(resetFirstChildMarginTop, {
				[`@media (min-width: ${breakpoints.medium})`]: {
					gridRow: '1/2',
				},
			}),
			'.supt-section__col': {
				[`@media (min-width: ${breakpoints.medium})`]: {
					gridRow: '2/3',
				},
			},

			'.supt-section__col--left': resetLastChildMarginBottom,

			'.supt-section__col--right': resetLastChildMarginBottom,
		}),
	});

const getEditStyles = () =>
	css({
		'.supt-section__inner': cssObj(grid, {
			'> .block-editor-inner-blocks > .block-editor-block-list__layout > .wp-block':
				{
					display: 'contents',
				},
		}),
	});

export { getStyles, getEditStyles };
